import PizZip from "pizzip";
import Docxtemplater from "docxtemplater";
import ImageModule from "docxtemplater-image-module-free";
import { base64ADatos } from "./assessmentExtractor";
import { obtenerDimensionesImagen, ajustarProporcional } from "./imageDimensions";

const RUTA_MACHOTE = `${process.env.PUBLIC_URL || ""}/documentos/Machote_BOM.docx`;

const RUTAS_LOGO_EMPRESA = {
  Netjer: `${process.env.PUBLIC_URL || ""}/img/NJ-Logotipo.png`,
  Rexten: `${process.env.PUBLIC_URL || ""}/img/rexten.png`,
};

const NOMBRES_EMPRESA = {
  Netjer: "Netjer Networks México",
  Rexten: "Rexten",
};

const PIXEL_TRANSPARENTE_BASE64 = "iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk+A8AAQUBAScY42YAAAAASUVORK5CYII=";

const cargarLogoEmpresa = async (empresa) => {
  const ruta = RUTAS_LOGO_EMPRESA[empresa] || RUTAS_LOGO_EMPRESA.Netjer;
  const respuesta = await fetch(ruta);
  if (!respuesta.ok) {
    throw new Error(`No se pudo cargar el logo de la empresa (${ruta}).`);
  }
  return new Uint8Array(await respuesta.arrayBuffer());
};

const TAMANO_MAXIMO_LOGO_PORTADA = [260, 130];
const TAMANO_MAXIMO_LOGO_EMPRESA_ENCABEZADO = [90, 40];
const TAMANO_MAXIMO_LOGO_CLIENTE_ENCABEZADO = [130, 55];
const TAMANO_MAXIMO_LOGO_EMPRESA_PORTADA = [140, 50];
const TAMANO_MAXIMO_BOM_IMAGEN = [450, 320];

const TAMANOS_MAXIMOS_POR_TAG = {
  logoCliente: TAMANO_MAXIMO_LOGO_PORTADA,
  logoClienteEncabezado: TAMANO_MAXIMO_LOGO_CLIENTE_ENCABEZADO,
  logoEmpresaEncabezado: TAMANO_MAXIMO_LOGO_EMPRESA_ENCABEZADO,
  logoEmpresaPortada: TAMANO_MAXIMO_LOGO_EMPRESA_PORTADA,
  bomImagen: TAMANO_MAXIMO_BOM_IMAGEN,
};

const crearModuloImagenes = () =>
  new ImageModule({
    centered: false,
    fileType: "docx",
    getImage: (tagValue) => tagValue,
    getSize: (imgBuffer, _tagValue, tagName) => {
      const tamanoMaximo = TAMANOS_MAXIMOS_POR_TAG[tagName] || TAMANO_MAXIMO_LOGO_PORTADA;
      return ajustarProporcional(obtenerDimensionesImagen(imgBuffer), tamanoMaximo);
    },
  });

export const generarDocumentoBOM = async ({ nombreProyecto, fechaCreacion, logoCliente, empresa, secciones }) => {
  const [respuesta, datosLogoEmpresa] = await Promise.all([
    fetch(RUTA_MACHOTE),
    cargarLogoEmpresa(empresa),
  ]);
  if (!respuesta.ok) {
    throw new Error("No se pudo cargar el machote de BOM (public/documentos/Machote_BOM.docx).");
  }
  const arrayBuffer = await respuesta.arrayBuffer();
  const zip = new PizZip(arrayBuffer);

  const doc = new Docxtemplater(zip, {
    paragraphLoop: true,
    linebreaks: true,
    nullGetter: () => "",
    modules: [crearModuloImagenes()],
  });

  const datosLogoCliente = logoCliente
    ? base64ADatos(logoCliente.base64)
    : base64ADatos(PIXEL_TRANSPARENTE_BASE64);

  const { imagenBom, ...seccionesSinImagenBom } = secciones;
  const datosImagenBom = imagenBom
    ? base64ADatos(imagenBom.base64)
    : base64ADatos(PIXEL_TRANSPARENTE_BASE64);

  try {
    await doc.renderAsync({
      nombreProyecto,
      fechaCreacion,
      logoCliente: datosLogoCliente,
      logoClienteEncabezado: datosLogoCliente,
      logoEmpresaEncabezado: datosLogoEmpresa,
      logoEmpresaPortada: datosLogoEmpresa,
      nombreEmpresa: NOMBRES_EMPRESA[empresa] || empresa,
      bomImagen: datosImagenBom,
      ...seccionesSinImagenBom,
    });
  } catch (error) {
    const detalle = error.properties && error.properties.errors
      ? error.properties.errors.map((e) => e.message).join("; ")
      : error.message;
    throw new Error(`No se pudo generar el BOM a partir del machote: ${detalle}`);
  }

  return doc.toBlob();
};